import { render, staticRenderFns } from "./CareTemplateSaveModal.vue?vue&type=template&id=767b35fd&scoped=true&"
import script from "./CareTemplateSaveModal.vue?vue&type=script&lang=js&"
export * from "./CareTemplateSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b35fd",
  null
  
)

export default component.exports